import { inject, Injectable } from '@angular/core'
import { BaseService } from './base.service'
import { type Observable } from 'rxjs'
import { map, mergeMap } from 'rxjs/operators'
import { type com } from 'efd-cdb_backend-interfaces-ts'
import { AuthService } from './auth.service'
import { jwtDecode, type JwtPayload } from 'jwt-decode'
import { NGXLogger } from 'ngx-logger'
import { type ClientId } from './kc-auth.service'

type TokenDTO = com.mocira.inside.cdb.client.dto.security.TokenDTO

type ParsedToken = JwtPayload & { azp: ClientId }

@Injectable({
  providedIn: 'root'
})

export class ImpersonateUserService extends BaseService {
  _isImpersonated: boolean

  private readonly authService = inject(AuthService)
  private readonly logger = inject(NGXLogger)

  impersonateUser (userId: number, dealerId: number): Observable<TokenDTO> {
    return this.http.get<TokenDTO>(`${this.apiUrl}/cdb/users/issue-token/user/${userId}/dealer/${dealerId}`).pipe(
      // save login, this also saves the token
      mergeMap(loginResponse => {
        return this.authService.setLogin(loginResponse)
      })
    )
  }

  isUserImpersonated (): Observable<boolean> {
    return this.authService.getToken().pipe(map(token => {
      if (!token) {
        return false
      }

      try {
        const decoded: ParsedToken = jwtDecode(token)
        return decoded.azp === 'impersonate-client'
      } catch {
        this.logger.error('Error decoding token', token)
        return false
      }
    }))
  }
}
